import { useQuery } from '@tanstack/react-query'
import { getUser, UserSessionRequestError } from './service'
import type { UserSession } from 'models/User'

const useUserSession = ({ enabled }: { enabled: boolean }) =>
  useQuery<UserSession, UserSessionRequestError>({
    queryKey: ['user-session'],
    queryFn: ({ signal }) => getUser(signal),
    refetchOnWindowFocus: false,
    retry: false,
    enabled,
  })

export default useUserSession
